/**
 * The Hauswerk mark: a solid house silhouette with the check knocked out of it.
 *
 * Deliberately one solid shape rather than outlines, it stays legible down to a
 * 16px favicon, where a stroked house collapses into a smudge.
 */
export function Logo({ size = 32, tone = 'brand' }: { size?: number; tone?: 'brand' | 'light' }) {
  // On the dark green sidebar a dark tile disappears, so the tones invert.
  const tile = tone === 'light' ? '#7fd6ab' : '#1c6b4a'
  const house = tone === 'light' ? '#0f3d2a' : '#ffffff'
  const cut = tile

  return (
    <svg viewBox="0 0 64 64" width={size} height={size} aria-hidden="true" focusable="false">
      <rect width="64" height="64" rx="15" fill={tile} />
      <path
        d="M32 12 54 30.5a2.6 2.6 0 0 1-1.6 4.6H49V50a3 3 0 0 1-3 3H18a3 3 0 0 1-3-3V35.1h-3.4A2.6 2.6 0 0 1 10 30.5Z"
        fill={house}
      />
      <path
        d="M23.5 38.5 29.5 44.5 41.5 31.5"
        fill="none"
        stroke={cut}
        strokeWidth="6.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Wordmark({
  size = 32,
  tone = 'brand',
  subtitle,
}: {
  size?: number
  tone?: 'brand' | 'light'
  subtitle?: string
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <Logo size={size} tone={tone} />
      <div className="wordmark-text" style={{ lineHeight: 1.15 }}>
        <div
          style={{
            fontSize: Math.round(size * 0.62),
            fontWeight: 750,
            letterSpacing: '-0.02em',
            color: tone === 'light' ? '#fff' : 'var(--ink-900)',
          }}
        >
          Haus<span style={{ color: tone === 'light' ? '#7fd6ab' : 'var(--green-700)' }}>werk</span>
        </div>
        {subtitle && (
          <div
            style={{
              fontSize: Math.round(size * 0.34),
              color: tone === 'light' ? 'rgba(255,255,255,0.7)' : 'var(--ink-400)',
              fontWeight: 500,
            }}
          >
            {subtitle}
          </div>
        )}
      </div>
    </div>
  )
}
